import { useCallback, useEffect } from 'react'
import { selectTaskTrackerProjectMembers } from '../../store/taskTracker.selectors'
import { useTaskTrackerDispatch, useTaskTrackerSelector } from '../../store/taskTracker.hooks'
import { fetchProjectMembersThunk } from '../../store/taskTracker.thunks'

type UseTaskTrackerProjectMembersOptions = {
  skipFetch?: boolean
}

export const useTaskTrackerProjectMembers = (
  projectId: number | null,
  options?: UseTaskTrackerProjectMembersOptions,
) => {
  const dispatch = useTaskTrackerDispatch()
  const skipFetch = options?.skipFetch ?? false
  const { members, roles, loading, error } = useTaskTrackerSelector((state) =>
    selectTaskTrackerProjectMembers(state, projectId),
  )

  useEffect(() => {
    if (projectId == null || skipFetch) return
    if (members.length > 0) return

    void dispatch(fetchProjectMembersThunk(projectId))
  }, [dispatch, members.length, projectId, skipFetch])

  const reloadMembers = useCallback(async () => {
    if (projectId == null) return

    await dispatch(
      fetchProjectMembersThunk({ projectId, force: true }),
    ).unwrap()
  }, [dispatch, projectId])

  return {
    members,
    roles,
    loading,
    error,
    reloadMembers,
  }
}
